import React, { useState } from 'react';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonials } from '../../mock';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section id="testimonials" className="py-24 px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-center mb-16">What clients say</h2>
        
        {/* Testimonial Card - Glassmorphic */}
        <div className="relative glass-card p-8 md:p-12">
          {/* Quote Icon */}
          <Quote size={48} className="text-[#7C3AED] opacity-20 mb-6" />
          
          {/* Testimonial Text */}
          <p className="text-xl md:text-2xl text-[#EDE9FE] leading-relaxed mb-8 italic">
            "{currentTestimonial.text}"
          </p>
          
          {/* Client Info */}
          <div className="flex items-center gap-4 border-t border-[#7C3AED]/10 pt-6">
            {/* Client Image/Logo */}
            <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 border border-[#7C3AED]/20">
              <img
                src={currentTestimonial.image}
                alt={currentTestimonial.company}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            
            {/* Client Details */}
            <div>
              <p className="text-lg font-semibold text-[#EDE9FE]">
                {currentTestimonial.author}
              </p>
              <p className="text-[#7C3AED] font-medium">
                {currentTestimonial.role}
              </p>
              <p className="text-sm text-[#9D97B5]">
                {currentTestimonial.company}
              </p>
            </div>
          </div>
          
          {/* Navigation Arrows */}
          <div className="flex gap-4 mt-8 justify-center">
            <button
              onClick={prevSlide}
              className="p-3 rounded-full bg-[#7C3AED]/10 text-[#7C3AED] hover:bg-[#7C3AED] hover:text-white transition-all duration-300"
              aria-label="Previous testimonial"
            >
              <ChevronLeft size={24} />
            </button>
            <button
              onClick={nextSlide}
              className="p-3 rounded-full bg-[#7C3AED]/10 text-[#7C3AED] hover:bg-[#7C3AED] hover:text-white transition-all duration-300"
              aria-label="Next testimonial"
            >
              <ChevronRight size={24} />
            </button>
          </div>
          
          {/* Dots Indicator */}
          <div className="flex gap-2 justify-center mt-6">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? 'w-8 bg-[#7C3AED]'
                    : 'w-2 bg-[#7C3AED]/30 hover:bg-[#7C3AED]/50'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
